<template>
  <div class="tg-user-id-field" @click.stop>
    <el-input
        :value="value"
        :size="size"
        :clearable="clearable"
        :placeholder="placeholder || $t('text.tgUserId')"
        :title="$t('text.tgUserIdHint')"
        @input="$emit('input', $event)"
    />
    <el-button
        type="success"
        :size="size === 'mini' ? 'mini' : 'small'"
        plain
        :loading="linkLoading"
        @click.stop="copyTgIdLink"
    >
      {{ $t('text.tgGetIdLink') }}
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'TgUserIdField',
  props: {
    value: {type: String, default: ''},
    size: {type: String, default: 'small'},
    clearable: {type: Boolean, default: true},
    placeholder: {type: String, default: ''}
  },
  data() {
    return {
      linkLoading: false
    };
  },
  methods: {
    copyTgIdLink() {
      this.linkLoading = true;
      this.$axios.get('/messagingAppUserInfo/tgUserIdLink', {params: {}}).then(res => {
        if (res.code !== 200 || !res.data) {
          this.$message.error(res.msg || this.$t('text.tgBindCreateFailed'));
          return;
        }
        const link = typeof res.data === 'string' ? res.data : String(res.data);
        const input = document.createElement('input');
        input.value = link;
        document.body.appendChild(input);
        input.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(input);
        if (ok) {
          this.$message.success(this.$t('text.tgGetIdCopiedToast'));
        } else {
          this.$message.error(this.$t('message.copyError'));
        }
      }).catch(() => {
        this.$message.error(this.$t('text.tgBindCreateFailed'));
      }).finally(() => {
        this.linkLoading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tg-user-id-field {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;

  .el-input {
    flex: 1;
    min-width: 0;
  }

  .el-button {
    flex-shrink: 0;
  }
}
</style>
